import { getErrorMessage } from 'application/util/error.util';

import './data.style.sass';
import template from './data.tpl.pug';

class DataSettingsController {
    /* @ngInject */
    constructor($q, $scope, $state, profileService, notificationService, modalService, sessionService) {
        this.$q = $q;
        this.$scope = $scope;
        this.$state = $state;
        this.profileService = profileService;
        this.notificationService = notificationService;
        this.modalService = modalService;
        this.sessionService = sessionService;
    }

    $onInit() {
        if (this.$state.params.action === 'restore') {
            this.restoreData();
        }
    }

    generateBackup() {
        return this.profileService.generateBackup().then((response) => {
            this.backupRequested = true;

            const message = response && response.message || `Backup requested. You will receive an email shortly containing the backup file.`;
            this.notificationService.showInfo(message, null, true, 5000);
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to generate your backup. Please try again later.`));
        });
    }

    restoreData() {
        this.modalService.open({
            component: 'dbAConfirmModal',
            bindings: {
                title: 'Restore from backup',
                message: [
                    'Restoring your data from a backup file will replace all the data in your account with the data from the selected backup file. If you have added transactions, calendars, etc. since the backup file has been generated, those will be overwritten.',
                    'Make sure you have the correct backup file before proceeding.'
                ],
                primaryButton: [
                    'Select file',
                    'Select file'
                ],
                secondaryButton: 'Cancel',
                buttonStyle: 'button-primary',
                onClose: () => {
                    return this.selectAndUploadBackupFile();
                }
            }
        }).catch(() => null);
    }

    selectAndUploadBackupFile() {
        const input = document.createElement('input');
        input.type = 'file';
        input.onchange = (event) => {
            const file = event.target.files[0];
            if (!file) {
                return this.$q.reject();
            }

            return this.$scope.$apply(() => {
                return this.modalService.open({
                    component: 'dbAConfirmModal',
                    bindings: {
                        title: 'Confirm restore',
                        message: [
                            `Selected file: ${this.normalizeFileName(file.name)}`,
                            'This action cannot be undone. Are you sure?'
                        ],
                        wide: true,
                        checkboxLabel: `Just check backup file integrity, don't import.`,
                        primaryButton: [
                            'Restore from selected file',
                            'Restoring...'
                        ],
                        checkboxPrimaryButton: [
                            'Check selected file',
                            'Checking...'
                        ],
                        secondaryButton: 'Cancel',
                        onClose: (dryRun) => {
                            return this.profileService.importBackup(file, !!dryRun).then((response) => {
                                if (response.status === 'SUCCESS' || response.status === 'DRY_RUN_SUCCESS') {
                                    const successMessage = dryRun
                                        ? 'Backup file integrity check completed successfully. The backup can be imported.'
                                        : response.message || 'Your data has been restored successfully.';

                                    this.notificationService.showInfo(
                                        successMessage,
                                        null,
                                        true,
                                        5000
                                    );
                                    if (!dryRun) {
                                        return this.sessionService.reload();
                                    }
                                    return this.$q.resolve();
                                }
                                if (response.status === 'DISABLED') {
                                    this.notificationService.showError(response.message || 'Backup restore is currently disabled.');
                                    return this.$q.reject();
                                }
                                this.notificationService.showError(response.message || 'Failed to restore backup.');
                                return this.$q.reject();
                            }).catch((result) => {
                                this.notificationService.showError(getErrorMessage(result, 'We were not able to restore your backup. Please try again later.'));
                                return this.$q.reject(result);
                            });
                        }
                    }
                }).catch(() => null);
            });
        };

        input.click();
        return this.$q.resolve();
    }

    normalizeFileName(fileName, maxLength = 60) {
        if (!fileName || fileName.length <= maxLength) {
            return fileName;
        }

        const ellipsis = '...';
        const remainingLength = maxLength - ellipsis.length;
        const startLength = Math.ceil(remainingLength / 2);
        const endLength = Math.floor(remainingLength / 2);

        return `${fileName.slice(0, startLength)}${ellipsis}${fileName.slice(-endLength)}`;
    }

    sendExportEmail() {
        return this.profileService.export().then(() => {
            this.exportEmailSent = true;

            this.notificationService.showInfo(`The email has been sent to your inbox.`, null, true, 3000);
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to export your data and send it to your through email. Please try again later.`));
        });
    }

    exportCsv() {
        return this.profileService.exportCsv()
            .then(() => {
                this.exportDownloaded = true;
            })
            .catch((result) => {
                this.notificationService.showError(getErrorMessage(result, `We were not able to export your data and send it to your through email. Please try again later.`));
            });
    }
}

export default {
    selector: 'dbADataSettings',
    template: template(),
    controller: DataSettingsController
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/data/data.cmpt.js